const baseNotes = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#','A', 'A#', 'B' ];
const NOTE_TO_INDEX = {
    'C': 0,
    'C#': 1,
    'D': 2,
    'D#': 3,
    'E': 4,
    'F': 5,
    'F#': 6,
    'G': 7,
    'G#': 8,
    'A': 9,
    'A#': 10,
    'B': 11,
};
const octaves = [1,2,3,4,5,6,7];

const BLACK_NOTES = {
    'C#': true, 'D#': true, 'F#': true, 'G#': true, 'A#': true
};

const STRING_TO_NOTE = {};

class Note {
    constructor(note, octave) {
        if (note === undefined) {
            note = 'C';
        }
        this.note = note.toUpperCase();
        this.octave = octave;
    }

    isBlackNote() {
        return BLACK_NOTES[this.note];
    }

    transpose(i) {
        // what octave is it

        let noteIndex = NOTE_TO_INDEX[this.note];
        let remainder = Math.floor(modulo(i, 12));
        let div = Math.floor(i / 12);
        return new Note(baseNotes[remainder], this.octave + div);
    }

    addTranspose(i) {
        let noteIndex = NOTE_TO_INDEX[this.note];
        let remainder = Math.floor(modulo(i + noteIndex, 12));
        let div = Math.floor((i + noteIndex) / 12);
        return new Note(baseNotes[remainder], this.octave + div);
    }

    toString() {
        return this.note + this.octave;
    }

    getTranspose() {
        let noteIndex = this.noteIndex();
        let oct = this.octave - middleC.octave;
        let noteDifference = this.noteIndex() - middleC.noteIndex();
        return oct*12 + noteDifference;
    }

    noteIndex() {
        return NOTE_TO_INDEX[this.note];
    }

    getCopy() {
        return new Note(this.note, this.octave);
    }

    equal(other) {
        return this.note === other.note &&
            this.octave === other.octave;
    }
}

const middleC  = new Note('C', 3);

function modulo(a, b) {
    return ((a%b)+b)%b;
}

function fromTranspose(transpose) {
    return middleC.getCopy().transpose(transpose);
}

function fromString(str, useCache=true) {
    if (useCache && STRING_TO_NOTE[str]) {
        let note = STRING_TO_NOTE[str];
        return note;
    } 
    let note = undefined;
    if (str.substring(1, 2) === '#') {
        note = new Note(str.substring(0, 2), parseInt(str.substring(2)));
    } else {
        note = new Note(str.substring(0, 1), parseInt(str.substring(1)));
    }

    if (useCache) {
        STRING_TO_NOTE[str] = note;
    }
    return note;
}

const NOTES = baseNotes.map(
        note => new Note(note, 3));

for (let i=0; i < 16; i++) {
    for (let j in baseNotes) {
        let note = baseNotes[j] + i;
        fromString(note);
    }
}

export default {Note, middleC, fromString, fromTranspose, NOTES, baseNotes};
